import dayjs from 'dayjs'
import regexp from './regexp'
import { ref } from 'vue'
import i18n from '@/i18n'

export class Formatter {
  public readonly locale = ref(i18n.global.locale)

  number = (value: number) => {
    return value.toLocaleString('ko-KR')
  }

  currency = (value: number, locale?: string) => {
    locale ??= common.locale.value
    const currency = locale === 'ko' ? 'KRW' : 'USD'
    const locales = locale === 'ko' ? 'ko-KR' : 'en-US'
    return value.toLocaleString(locales, { style: 'currency', currency })
  }

  date = (value: string, format: string = 'YYYY-MM-DD') => {
    return dayjs(value).locale(this.locale.value).format(format)
  }

  /**
   * 전화번호 형식으로 변환합니다
   *
   * @param value 숫자만 들어있는 값
   * @param locale 지역구분 (ko, en)
   */
  telephone = (value: string | undefined, locale: string = 'ko'): string => {
    if (!value) {
      return ''
    }

    value = value.replace(/[^\d]/g, '')

    if (locale === 'en') {
      return this.telephoneOversea(value)
    }

    return this.telephoneKo(value)
  }

  /**
   * 국내 전화번호 표기형식으로 리턴한다
   *
   * @param value only numbers
   * @returns 02-####-####
   */
  telephoneKo(value: string): string {
    value = value.replace(/[^\d]/g, '')

    if (regexp.mobileKorean.test(value)) {
      return this.mobileKo(value)
    }

    if (regexp.telephoneKoreanRegion.test(value)) {
      return regexp.telephoneKoreanRegion.exec(value).join('-')
    }

    if (regexp.telephoneKoreanNoRegion.test(value)) {
      return regexp.telephoneKoreanNoRegion.exec(value).join('-')
    }

    return value
  }

  /**
   * 국내 휴대전화 표기형식으로 리턴한다
   *
   * @param value only numbers
   * @returns 010-####-####
   */
  mobileKo(value: string): string {
    value = value.replace(/[^\d]/g, '')

    if (regexp.mobileKorean.test(value)) {
      return regexp.mobileKorean.exec(value).join('-')
    }

    return value
  }

  telephoneOversea(value: string): string {
    return '+82-' + value.replace(/^0(.+)$/, '$1')
  }

  bizNumber(value: string | undefined): string {
    if (!value) {
      return ''
    }

    value = value.replace(/[^\d]/g, '')

    if (value.length !== 10) {
      return value
    }

    return value.replace(/(\d{3})(\d{2})(\d{5})/, '$1-$2-$3')
  }
}

export const format = new Formatter()
